import React from 'react';
import { Link } from 'react-router-dom';
import { LeafIcon } from 'lucide-react';
export function Logo() {
  return <Link to="/" aria-label="Chacon's Lawncare home" className="flex shrink-0 items-center gap-3 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2" data-id="element-384" data-mp="yc7mu8983x87">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-olive" data-id="element-385" data-mp="oet585bkd2eb">
        <LeafIcon className="h-5 w-5 text-sage-light" aria-hidden="true" data-id="element-386" data-mp="kcg3drzxtomt" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-387" data-mp="fitzopbr4v35">
        <span className="font-display text-lg font-semibold tracking-wide text-forest" data-id="element-388" data-mp="al25tprjqywb">CHACON’S</span>
        <span className="mt-1 text-[10px] font-bold tracking-[0.34em] text-olive" data-id="element-389" data-mp="5mqxxkktaygq">LAWNCARE</span>
      </span>
    </Link>;
}